import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  OAuthProvider,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBDgiqSTEJ1WJ-2IaESi4sh5_uGhjOxm7Y",
  authDomain: "modular-objects.firebaseapp.com",
  projectId: "modular-objects",
  storageBucket: "modular-objects.appspot.com",
  messagingSenderId: "593324708848",
  appId: "1:593324708848:web:3b5d38d98de7d1296c8335",
  measurementId: "G-SLML7SXRHN"
};

// Inicijalizacija Firebase aplikacije
const firebaseApp = initializeApp(firebaseConfig);

// Inicijalizacija Auth sa persistencijom
const auth = getAuth(firebaseApp);
setPersistence(auth, browserLocalPersistence)
  .then(() => console.log("Persistence set to local"))
  .catch((error) => console.error("Persistence error:", error));

// Konfiguracija provajdera
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

const microsoftProvider = new OAuthProvider("microsoft.com");
microsoftProvider.setCustomParameters({
  prompt: 'select_account'
});

// Apple provider (ako bude potreban)
const appleProvider = new OAuthProvider("apple.com");
appleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Eksport svih potrebnih promenljivih
export { 
  firebaseApp as app, // Eksportujemo kao 'app' za kompatibilnost
  auth,
  googleProvider,
  microsoftProvider,
  appleProvider
};